import { render, staticRenderFns } from "./EspaciosTable.view.vue?vue&type=template&id=30154456&scoped=true"
import script from "./EspaciosTable.view.vue?vue&type=script&lang=js"
export * from "./EspaciosTable.view.vue?vue&type=script&lang=js"
import style0 from "./EspaciosTable.view.vue?vue&type=style&index=0&id=30154456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30154456",
  null
  
)

export default component.exports